import { render, staticRenderFns } from "./StandingsTab.vue?vue&type=template&id=1b087c0a"
import script from "./StandingsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StandingsTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports